import gql from 'graphql-tag';

export const CHECK_IS_BPFS_EXIST_FOR_ACCOUNT = gql`
  query GetBusinessProcessFlowTemplates($input: BPFTemplatesInput!) {
    bpf {
      templates(input: $input) {
        templates {
          businessProcessFlowId
        }
      }
    }
  }
`;
